import { Loader2 } from 'lucide-react'

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/modules/shared/components/ui/card'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/modules/shared/components/ui/dialog'
import { ScrollArea } from '@/modules/shared/components/ui/scroll-area'
import type { Entity } from '@/modules/shared/types/entity.type'

import { useScheduleFormStore } from '../stores/schedule-form.store'

type ModalEntityComponent = {
  isLoading: boolean
  onSelectClient: (entity: Entity) => void
}

export function ModalCustomerComponent({
  isLoading,
  onSelectClient,
}: ModalEntityComponent) {
  const {
    customers,
    isOpenModalCustomer,
    actions: { setCustomers, setIsOpenModalCustomer },
  } = useScheduleFormStore()

  const handleClose = () => {
    setCustomers([])
    setIsOpenModalCustomer(false)
  }

  return (
    <Dialog open={isOpenModalCustomer} onOpenChange={handleClose}>
      <DialogContent className="bg-[#F0F2F5]">
        <DialogHeader>
          <DialogTitle>Clientes</DialogTitle>
        </DialogHeader>
        <ScrollArea>
          <div className="max-h-[70vh] space-y-2 cursor-pointer">
            {isLoading && (
              <div className="justify-center items-center h-full flex flex-col">
                <Loader2 size={32} className="animate-spin text-primary" />
                <p className="pt-6">Carregando clientes...</p>
              </div>
            )}

            {!isLoading &&
              customers.map((entity) => (
                <Card
                  key={entity?.idEntidade}
                  className="cursor-pointer hover:cursor-pointer hover:bg-slate-200"
                  onClick={() => onSelectClient(entity)}
                >
                  <CardHeader className="p-3 -mb-4">
                    <CardTitle className="text-sm text-balance">
                      {entity?.idEntidade} - {entity?.razaoSocialNome}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="p-3">
                    <p className="text-xs">{entity?.cnpjCpf}</p>
                    <p className="text-xs">
                      {entity?.logradouro}, {entity?.numero}
                    </p>
                    <p className="text-xs">
                      {entity?.cidade}, {entity?.uf}
                    </p>
                  </CardContent>
                </Card>
              ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  )
}
